<template>
<div>
    <div v-if="!isMobile">
        
        <div class="div_001">
            <div class="div_001_001">
                <div @click="nav_001('')"></div>
                <div>
                    <div @click="nav_001('Features')">     Features     </div>
                    <div @click="nav_001('Applications')"> Applications </div>
                    <div @click="nav_001('Projects')">     Projects     </div>
                    <div @click="nav_001('About')">        About Us     </div>
                    <div @click="nav_001('Contact')">      Contact Us   </div>
                </div>
                <div>
                    <div></div> <div> EN </div>
                </div>
            </div>
        </div>
        
        <div class="div_002">
            <div class="div_002_001">
                <div @click="nav_001('')"></div>
                <div><div><div></div></div></div> <div> Projects </div>
                <div><div><div></div></div></div> <div> {{v_text}} </div>
            </div>
        </div>
        
        <div class="div_003" :style="{ 'height' : screenHeight - 168 + 'px' }">
            <div class="div_003_001">
                <div><img :class="(param_001.split('&')[1] == 'image_001.png' || param_001.split('&')[1] == 'image_006.png') ? 'img_h_001' : 'img_w_001' " :src="v_image"/></div>
                <div>
                    <div class="iconfont_002">
                         {{v_text}} 
                    </div>
                    <div>
                        <span> Client </span>
                        <span> Guangzhou Dongli Exhibition Architecture Co., Ltd. </span>
                    </div>
                    <div>
                        <span> Scope </span>
                        <span> Full exhibition booth construction using MineWay mineral fiber panels throughout. </span>
                    </div>
                    <div>
                        <span> Size </span>
                        <span> 112.5 m² </span>
                    </div>
                    <div>
                        <span> Location </span>
                        <span> Guangzhou, China </span>
                    </div>
                    <div>
                        <span> Year </span>
                        <span> 2025 </span>
                    </div>
                </div>
            </div>
        </div>
        
        <div class="div_004">
            <div class="div_004_001">
                <div></div> <div></div> <div></div> <div></div>
            </div>
        </div>
        
    </div>
    
    <div v-if="isMobile">
        
        <div class="div_mobile_001">
            <div class="div_mobile_001_001">
                <div class="div_mobile_001_001_l" @click="nav_001('')"></div>
                <div class="div_mobile_001_001_r" @click="fun_002()">
                    <div></div>
                    <div></div>
                    <div></div>
                </div>
            </div>
        </div>
        
        <div id="div_mobile_menu" class="div_mobile_menu" :style="{ height: screenHeight + 'px', top: -screenHeight + 'px' }">
            <div @click="nav_001('Features')">     Features     </div>
            <div @click="nav_001('Applications')"> Applications </div>
            <div @click="nav_001('Projects')">     Projects     </div>
            <div @click="nav_001('About')">        About Us     </div>
            <div @click="nav_001('Contact')">      Contact Us   </div>
            <div :style="{ 'height' : screenHeight - 438 + 'px' }"  @click="fun_002()"></div>
        </div>
        
        <div class="div_mobile_002">
            <div class="div_mobile_002_001">
                <div @click="nav_001('')"></div>
                <div><div><div></div></div></div> <div> Projects </div>
                <div><div><div></div></div></div> <div> {{v_text}} </div>
            </div>
        </div>
        
        <div class="div_mobile_003">
            <div class="div_mobile_003_001">
                <div><img :class="(param_001.split('&')[1] == 'image_001.png' || param_001.split('&')[1] == 'image_006.png') ? 'img_h_001' : 'img_w_001' " :src="v_image"/></div>
                <div>
                    <div class="iconfont_002">
                         {{v_text}} 
                    </div>
                    <div>
                        <span> Client </span>
                        <span> Guangzhou Dongli Exhibition Architecture Co., Ltd. </span>
                    </div>
                    <div>
                        <span> Scope </span>
                        <span> Full exhibition booth construction using MineWay mineral fiber panels throughout. </span>
                    </div>
                    <div>
                        <span> Size </span>
                        <span> 112.5 m² </span>
                    </div>
                    <div>
                        <span> Location </span>
                        <span> Guangzhou, China </span>
                    </div>
                    <div>
                        <span> Year </span>
                        <span> 2025 </span>
                    </div>
                </div>
            </div>
        </div>
        
        <div class="div_mobile_004">
            <div class="div_mobile_004_001">
                <div></div> <div></div> <div></div> <div></div>
            </div>
        </div>
        
    </div>
</div>
</template>

<script>
export default {
    data() {
        return {
            isMobile     : false,
            screenHeight : 0,
            scrollTop    : 0,
            
            v_text       : '',
            v_image      : '',
        };
    },
    props : ["param_001"],
    created() {
        // 监听；
        window.addEventListener('resize', this.checkIsMobile);
        // window.addEventListener('scroll', this.checkScrollTop);
        
        // console.log(this.param_001);
        
        this.v_text  = this.param_001.split('&')[0];
        
        this.v_image = require('../assets/04 Projects/' + this.param_001.split('&')[1]);
        
        // 置顶；
        window.scrollTo(0, 0);
    },
    mounted() {
        let that = this;
        
        document.title = '';
        
        this.checkIsMobile();
        this.checkScreenHeight();
    },
    destroyed() {
        window.removeEventListener('resize', this.checkIsMobile);
        // window.removeEventListener('scroll', this.checkScrollTop);
    },
    methods: {
        // 检测移动设备；
        checkIsMobile() {
            const width = window.innerWidth || document.documentElement.clientWidth;
            let isMobile_001 = width <= 768;
            
            const userAgent = window.navigator.userAgent;
            let isMobile_002 = /iPhone|iPad|iPod|Android/i.test(userAgent);
             
            this.isMobile = isMobile_001 || isMobile_002;
            
            // console.log("移动设备判断方式一：", isMobile_001);
            // console.log("移动设备判断方式二：", isMobile_002);
        },
        // 检测屏幕高度；
        checkScreenHeight() {
            const height = window.innerHeight || document.documentElement.clientHeight;
            this.screenHeight = height;
        },
        // 事件 - 导航栏跳转；
        nav_001( param ) {
            this.$router.push( "/" + param );
        },
        // 事件 - 移动端导航栏；
        fun_002( ) {
            
            let that = this;
            
            let offset = Number(document.getElementById( 'div_mobile_menu' ).style.top.split('px')[0]);
            
            console.log(offset);
            
            if ( offset < 0 ) {
                
                var menu_move = setInterval( () => {
                    
                    let offset = Number(document.getElementById( 'div_mobile_menu' ).style.top.split('px')[0]);
                    
                    document.getElementById( 'div_mobile_menu' ).style.top = Number(offset) + 6 + 'px';
                    
                    if( document.getElementById( 'div_mobile_menu' ).style.top.split('px')[0] >= 0 ) {
                        
                        document.getElementById( 'div_mobile_menu' ).style.top = '0px';
                        
                        clearInterval( menu_move );
                    }
                    
                }, 0 );
                
            } else {
                
                var menu_move = setInterval( () => {
                    
                    let offset = Number(document.getElementById( 'div_mobile_menu' ).style.top.split('px')[0]);
                    
                    document.getElementById( 'div_mobile_menu' ).style.top = Number(offset) - 6 + 'px';
                    
                    if( document.getElementById( 'div_mobile_menu' ).style.top.split('px')[0] <= -that.screenHeight ) {
                    
                        document.getElementById( 'div_mobile_menu' ).style.top = -that.screenHeight;
                        
                        clearInterval( menu_move );
                    }
                    
                }, 0 );
                
            }
        },
    }
};
</script>

<style scoped>
/*** ************************************************* ***/

.div_001 {
    width: 100%;
    height: 88px;
    
    color: #F7F4EC;
    background-color: #151513;
    
    position: fixed;
    top: 0px;
    
    z-index: 9999999;
}

.div_001_001 {
    width: 1440px;
    height: 100%;
    
    background-color: #151513;
    
    margin: 0 auto;
    
    display : flex;
    flex-direction : row;
    justify-content : center;
    align-items : center;
    
    position: relative;
}

.div_001_001 > div:first-child {
    width: 137px;
    height: 32px;
    
    cursor: pointer;
    
    background-image : url('../assets/image_000_001.png');
    background-repeat : no-repeat;
    background-position : center;
    background-size : 100%;
    
    position: absolute;
    top: 28px;
    left: 32px;
}

.div_001_001 > div:nth-child(2) {
    width: 885px;
    
    font-size: 16px;
    font-weight: 500;
    
    display : flex;
    flex-direction : row;
    justify-content : space-between;
    align-items : center;
}

.div_001_001 > div:nth-child(2) > div {
    cursor: pointer;
}

.div_001_001 > div:last-child {
    width: 54px;
    height: 24px;
    
    cursor: pointer;
    
    display : flex;
    flex-direction : row;
    justify-content : space-between;
    align-items : center;
    
    position: absolute;
    top: 32px;
    right: 32px;
}

.div_001_001 > div:last-child > div:first-child {
    width: 20px;
    height: 20px;
    
    background-image : url('../assets/image_000_003.png');
    background-repeat : no-repeat;
    background-position : center;
    background-size : 100%;
    
    position: relative;
    top: 0.5px;
}

.div_001_001 > div:last-child > div:last-child {
    font-size: 16px;
    font-weight: 500;
    
    display : flex;
    flex-direction : row;
    justify-content : center;
    align-items : center;
}

/*** ************************************************* ***/

.div_002 {
    width: 100%;
    height: 168px;
    
    color: #F7F4EC;
    background-color: #151513;
}

.div_002_001 {
    width: 1440px;
    height: 100%;
    
    margin: 0 auto;
    
    display : flex;
    flex-direction : row;
    justify-content : flex-start;
    align-items : flex-start;
}

.div_002_001 > div:first-child {
    width: 24px;
    height: 24px;
    
    margin-top: 120px;
    margin-left: 32px;
    
    cursor: pointer;
    
    background-image : url('../assets/image_000_005.png');
    background-repeat : no-repeat;
    background-position : center;
    background-size : 100%;
}

.div_002_001 > div:nth-child(2) ,
.div_002_001 > div:nth-child(4) {
    width: 24px;
    height: 24px;
    
    margin-top: 120px;
    margin-left: 22px;
    
    cursor: pointer;
    
    display : flex;
    flex-direction : row;
    justify-content : flex-start;
    align-items : center;
}

.div_002_001 > div:nth-child(2) > div ,
.div_002_001 > div:nth-child(4) > div {
    width : 0px;
    height: 0px;
    
    border-top : 8px solid transparent;
    border-left : 8px solid #F7F4EC;
    border-right : 8px solid transparent;
    border-bottom : 8px solid transparent;
    
    display : flex;
    flex-direction : row;
    justify-content : flex-start;
    align-items : center;
    
    position: relative;
}

.div_002_001 > div:nth-child(2) > div > div ,
.div_002_001 > div:nth-child(4) > div > div {
    width : 0px;
    height: 0px;
    
    border-top : 5px solid transparent;
    border-left : 5px solid #151513;
    border-right : 5px solid transparent;
    border-bottom : 5px solid transparent;
    
    position: absolute;
    left: -8px;
}

.div_002_001 > div:nth-child(3) ,
.div_002_001 > div:last-child   {
    width : 60px;
    height: 24px;
    
    font-size: 16px;
    
    margin-top: 120px;
    margin-left: 5px;
    
    cursor: pointer;
    
    display : flex;
    flex-direction : row;
    justify-content : flex-start;
    align-items : center;
}

.div_002_001 > div:last-child   {
    width : 200px;
}

/*** ************************************************* ***/

.div_003 {
    width: 100%;
    background-color: #151513;
}

.div_003_001 {
    width: 1440px;
    height: 100%;
    
    margin: 0 auto;
    
    display : flex;
    flex-direction : row;
    justify-content : space-between;
    align-items : center;
}

.div_003_001 > div:first-child {
    width: 880px;
    height: 100%;
    
    overflow: hidden;
}

.img_w_001 {
    width: 100%;
}

.img_h_001 {
    height: 100%;
}

.div_003_001 > div:last-child {
    width: 880px;
    height: 100%;
    
    display : flex;
    flex-direction : column;
    justify-content : center;
    align-items : center;
}

.div_003_001 > div:last-child > div {
    width: 75%;
    height: 52px;
    
    color: #F7F4EC;
    font-size: 16px;
    
    border-bottom: 1px solid #7D7D7D;
    
    display : flex;
    flex-direction : row;
    justify-content : flex-start;
    align-items : center;
}

.div_003_001 > div:last-child > div > span:first-child {
    width: 20%;
    text-align: left;
}

.div_003_001 > div:last-child > div > span:last-child {
    width: 80%;
    text-align: left;
}

.div_003_001 > div:last-child > div:first-child {
    height: 82px;
    
    font-size: 36px;
    font-weight: 600;
}

.div_003_001 > div:last-child > div:nth-child(3) {
    height: 82px;
}

/*** ************************************************* ***/

.div_004 {
    width: 100%;
    height: 1066px;
    
    background-color: #F7F4EC;
}

.div_004_001 {
    width: 1440px;
    height: 100%;
    
    margin: 0px auto;
    
    display : flex;
    flex-direction : row;
    justify-content : center;
    align-items : flex-start;
    
    flex-wrap: wrap;
}

.div_004_001 > div {
    width: 576px;
    height: 485px;
    
    margin: 32px 16px 0px;
    
    border-radius: 16px;
    
    background-image : url('../assets/04 Projects/04_01 Project/image_001.jpg');
    background-repeat : no-repeat;
    background-position : center;
    background-size : 190%;
}

.div_004_001 > div:nth-child(3) ,
.div_004_001 > div:nth-child(4) {
    margin-top: 0px;
}

/*** ************************************************* ***/
/*** ************************************************* ***/

.div_mobile_001 {
    width: 100%;
    height: 88px;
    
    background-color: #151513;
    
    display : flex;
    flex-direction : column;
    justify-content : center;
    align-items : center;
    
    position: fixed;
    top: 0px;
    
    z-index: 9999999;
}

.div_mobile_001_001 {
    width: 90%;
    height: 100%;
    
    display : flex;
    flex-direction : row;
    justify-content : space-between;
    align-items : center;
}

.div_mobile_001_001_l {
    width: 137px;
    height: 32px;
    
    background-image : url('../assets/image_000_001.png');
    background-repeat : no-repeat;
    background-position : center;
    background-size : 100%;
}

.div_mobile_001_001_r {
    width: 40px;
    height: 40px;
    
    background-color: #F7F4EC;
    
    border-radius: 4px;
        
    display : flex;
    flex-direction : column;
    justify-content : center;
    align-items : center;
}

.div_mobile_001_001_r > div {
    width: 28px;
    height: 3px;
    
    margin-top: 2.5px;
    margin-bottom: 2.5px;
    
    border-radius: 2px;
    
    background-color: #151513;
}

.div_mobile_menu {
    width: 100%;
    
    display : flex;
    flex-direction : column;
    justify-content : flex-start;
    align-items : center;
    
    position: fixed;
    left: 0px;
    
    z-index: 999999;
}

.div_mobile_menu > div {
    width: 100%;
    height: 70px;
    
    display : flex;
    flex-direction : column;
    justify-content : center;
    align-items : center;
    
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
    
    background-color: #F7F4EC;
}

.div_mobile_menu > div:first-child {
    margin-top: 88px;
}

.div_mobile_menu > div:last-child {
    width: 100%;
    
    background-color: rgba(0, 0, 0, 0);
}

/*** ************************************************* ***/

.div_mobile_002 {
    width: 100%;
    
    color: #F7F4EC;
    background-color: #151513;
}

.div_mobile_002_001 {
    width: 90%;
    height: 100%;
    
    margin: 0 auto;
    
    display : flex;
    flex-direction : row;
    justify-content : flex-start;
    align-items : flex-start;
}

.div_mobile_002_001 > div:first-child {
    width: 24px;
    height: 24px;
    
    margin-top: 120px;
    
    cursor: pointer;
    
    background-image : url('../assets/image_000_005.png');
    background-repeat : no-repeat;
    background-position : center;
    background-size : 100%;
}

.div_mobile_002_001 > div:nth-child(2) ,
.div_mobile_002_001 > div:nth-child(4) {
    width: 24px;
    height: 24px;
    
    margin-top: 120px;
    margin-left: 22px;
    
    cursor: pointer;
    
    display : flex;
    flex-direction : row;
    justify-content : flex-start;
    align-items : center;
}

.div_mobile_002_001 > div:nth-child(2) > div ,
.div_mobile_002_001 > div:nth-child(4) > div {
    width : 0px;
    height: 0px;
    
    border-top : 8px solid transparent;
    border-left : 8px solid #F7F4EC;
    border-right : 8px solid transparent;
    border-bottom : 8px solid transparent;
    
    display : flex;
    flex-direction : row;
    justify-content : flex-start;
    align-items : center;
    
    position: relative;
}

.div_mobile_002_001 > div:nth-child(2) > div > div ,
.div_mobile_002_001 > div:nth-child(4) > div > div {
    width : 0px;
    height: 0px;
    
    border-top : 5px solid transparent;
    border-left : 5px solid #151513;
    border-right : 5px solid transparent;
    border-bottom : 5px solid transparent;
    
    position: absolute;
    left: -8px;
}

.div_mobile_002_001 > div:nth-child(3) ,
.div_mobile_002_001 > div:last-child   {
    width : 60px;
    height: 24px;
    
    font-size: 16px;
    
    margin-top: 120px;
    margin-left: 5px;
    
    cursor: pointer;
    
    display : flex;
    flex-direction : row;
    justify-content : flex-start;
    align-items : center;
}

.div_mobile_002_001 > div:last-child   {
    width : 200px;
}

/*** ************************************************* ***/

.div_mobile_003 {
    width: 100%;
    background-color: #151513;
}

.div_mobile_003_001 {
    width: 90%;
    
    padding-top: 20px;
    
    margin: 0 auto;
    
    display : flex;
    flex-direction : column;
    justify-content : flex-start;
    align-items : center;
}

.div_mobile_003_001 > div:first-child {
    width: 300px;
    height: 300px;
    
    overflow: hidden;
}

.img_w_001 {
    width: 100%;
}

.img_h_001 {
    height: 100%;
}

.div_mobile_003_001 > div:last-child {
    width: 300px;
    
    display : flex;
    flex-direction : column;
    justify-content : center;
    align-items : center;
}

.div_mobile_003_001 > div:last-child > div {
    width: 100%;
    height: 52px;
    
    color: #F7F4EC;
    font-size: 14px;
    
    border-bottom: 1px solid #7D7D7D;
    
    display : flex;
    flex-direction : row;
    justify-content : flex-start;
    align-items : center;
}

.div_mobile_003_001 > div:last-child > div > span:first-child {
    width: 25%;
    text-align: left;
}

.div_mobile_003_001 > div:last-child > div > span:last-child {
    width: 75%;
    text-align: left;
}

.div_mobile_003_001 > div:last-child > div:first-child {
    height: 82px;
    
    font-size: 20px;
    font-weight: 600;
}

.div_mobile_003_001 > div:last-child > div:nth-child(3) {
    height: 82px;
}

/*** ************************************************* ***/

.div_mobile_004 {
    width: 100%;
    
    background-color: #F7F4EC;
}

.div_mobile_004_001 {
    width: 100%;
    
    margin: 0px auto;
    
    display : flex;
    flex-direction : row;
    justify-content : center;
    align-items : flex-start;
    
    flex-wrap: wrap;
}

.div_mobile_004_001 > div {
    width: 300px;
    height: 300px;
    
    margin: 32px 16px 0px;
    
    border-radius: 16px;
    
    background-image : url('../assets/04 Projects/04_01 Project/image_001.jpg');
    background-repeat : no-repeat;
    background-position : center;
    background-size : 190%;
}

.div_mobile_004_001 > div:last-child {
    margin-bottom: 32px;
}

/*** ************************************************* ***/
</style>